import React, { Component } from "react";
import LeftPicture from '../Section/LeftPicture';
import UserLight from "../Section/UserLight";
import LeftPictureBackgroundLarge from "../Section/LeftPictureBackgroundLarge";
import picture from "./img/innovation-web.png";
import analyse from "./img/analyse.jpg";
import maquette from "./img/maquette.jpg";
import conseil from "./img/conseil.jpg";
import development from "./img/development.jpg";
import launch from "./img/launch.png";
import architecture from "./img/architecture.jpg";
import challenge from "./img/challenge.png";
import MainPicture from "../Section/MainPicture";
import integral from "./img/logo-integral-system.png";
import pixel from "./img/pole-pixel-villeurbanne-integral-service.jpg";
import styles from "./StartUp.module.scss";
import success from "./img/success.jpg";
import idea from "./img/idea.png";

class StartUp extends Component {
  render() {
    let smalltitle = "Parce que c'est votre projet";
    let title = "Votre STARTUP";
    let description = ["Nous ", <strong>aidons les startups à réussir</strong>, " en créant des applications et sites sur-mesure pour tous les besoins.", <br />, <br />, "Nous prenons en charge la partie technique de votre projet afin que vous puissiez ", <strong>vous concentrer sur l'évolution de votre startup</strong>,"."];
    let alt = "Integral Service et innovation";

    let smalltitleAbout = "Parce que c'est votre projet";
    let titleAbout = "Rendons vos idées réelles !";
    let descriptionAbout = [<br />,"Concentrez-vous sur le ", <strong>développement de votre Startup</strong>," tout en vous assurant l'expertise technique de nos équipes.", <br/>,<br/>, "Nous façonnons des solutions innovantes à votre image."];
    let altAbout = "Challenge Integral Service";


    let industrie4 = [
      "Integral Service fait partie de la société ", <a href="https://www.integral-system.fr" title="Société Integral System">Integral System</a>," créée en 2003, ", <strong>spécialiste de l'informatique industrielle et l'automation</strong>, ".", 
      <br />, <br />, 
      
      "Notre expertise de l'environnement industriel couplé à notre savoir-faire dans le milieu du Web est une combinaison gagnante dans le cadre de la mise en place d'environnements Web au sein des industries ainsi que dans le monde de l'IoT (Internet des Objets). ", <br />, <br />,"Nous vous accompnons dans ",<strong>l'entrée vers l'industrie 4.0.</strong>
    ];
    return (
      <div className={`${styles.aboutcontainer} `}>
          <div className="container">
            <div className={`row row-bottom-padded-md row-top-padded-md ${styles.homepagetopcontainer}`}>
                <div className="col-lg-12 text-center">
                    <h2 className={`${styles.fh5colead} animate-box`}>Un seul objectif: Votre réussite !</h2>
                    <img src={challenge} alt="Réussite de vos projets d'entrepreneur" className={`img-fluid p-4 pb-5 ${styles.teamtitle}`}/>
                    <p className={`${styles.bigpar}`} ><strong>Notre mission</strong> est de <strong>vous accompagner techniquement</strong> dans votre projet afin de vous aider à le <strong>concrétiser</strong>.</p>
                </div>
            </div>
        </div>
      <LeftPictureBackgroundLarge 
            smalltitle={smalltitleAbout}
            title={titleAbout}
            description={descriptionAbout}
            picture={idea}
            alt={altAbout}
        />

            <div className="team row-bottom-padded-lg row-top-padded-lg">
            <div className="container">

                <h2 className={`text-center pb-5 ${styles.teamtitle} `}>Un accompagnement sur-mesure</h2>
                <div className={`row ${styles.teamcontainer} `}>
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <UserLight name="Conseil"
                    position="Force de proposition"
                    description="Nous vous accompagnons tout au long du projet en vous faisant profiter de l'expérience et l'expertise de nos équipes."
                    picture={conseil}
                    alt="Conseil web et mobile"  />
                  </div>
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <UserLight name="Analyse"
                    position="Technique et fonctionnelle"
                    description="Afin de réaliser la solution la plus adaptée, nous analysons avec vous votre projet afin d'en définir l'architecture et toute les étapes de déploiement."
                    picture={analyse}
                    alt="Julien Responsable technique Integral Service"
                    twitter="https://twitter.com/jurv_dev" />
                  </div>
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <UserLight name="Maquette"
                    position="Définition du PMV"
                    description="Nous travaillons en collaboration avec votre structure pour définir les maquettes de votre projet et éventuellement pour définir un produit minimum viable."
                    picture={maquette}
                    alt="Richard Développeur full stack"
                    twitter="https://twitter.com/richard0r" />
                  </div>
                </div>
                <div className={`row ${styles.devline2}`}>
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <UserLight name="Conception"
                    position="Stabilité et Scalabilité"
                    description="Nous proposons des solutions techniques pérennes et évolutives afin d'accompagner le développement et la réussite de votre projet. "
                    picture={architecture}
                    alt="Guy Développeur Web"
                    twitter="" />
                  </div>
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <UserLight name="Réalisation"
                    position="Qualité & Agilité"
                    description="Nous nous occupons de la réalisation technique tout en vous soumettant régulièrement les itérations de votre projet pour validation. "
                    picture={development}
                    alt="Vincent"
                    twitter="https://twitter.com/smashou" />
                  </div>
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <UserLight name="Déploiement et évolutions"
                    position="Chef de projet"
                    description="Votre projet ne se termine pas à son déploiement. Nous continuons de vous accompagner afin de vous proposer des solutions toujours adaptées."
                    picture={launch}
                    alt="Vincent"
                    twitter="https://twitter.com/smashou" />
                  </div>

                </div>
            </div>
        </div>
        
        
      </div>
    );
  }
}

export default StartUp;



// WEBPACK FOOTER //
// ./src/components/StartUp/StartUp.jsx